export { default } from './CookiesPolitics';
